

























import { Component } from "vue-property-decorator";
import Header from "@/components/header/MLoginHeader.vue";
import Footer from "@/components/Footer.vue";
import CheckAdminLogin from "@/utils/CheckAdminLogin";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class MRegisterPassEditComp extends CheckAdminLogin {}
